<div class="sidenav-content">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading && newsCard else loading">
			<ng-container *ngIf="newsCard">
				<div class="sidebar-tab-page-content copo-no-user-select sidenav-content">
					<div class="card-title-block-non-sticky">
						<div class="header-container">
							<button (click)="back()" class="back-button-icon" type="button" mat-icon-button>
								<mat-icon svgIcon="md:chevron_left"></mat-icon>
							</button>
							<span class="card-title-label">News Card - {{ newsCard.title }}</span>
						</div>
					</div>
					<div class="copo-container">
						<div class="card-block grid-column-one-full">
							<div class="card-title start-date">
								<span *ngIf="news">{{ news.from ? (news.from | date: 'yyyy/MM/dd HH:mm') : UNDERSCORE }}</span>
							</div>
							<div class="news-card-title">
								<span>{{ newsCard.title }}</span>
							</div>
							<div class="card-infos-block news-card-desc">
								<p class="card-info" [innerHTML]="newsCard.content"></p> 
							</div>
							<div class="files-list" *ngFor="let attachment of newsCard?.attachments;let i= index">
								<a class="file-item" *ngIf="attachment" target="_blank" rel="noopener" [href]="getDocumentURL(attachment.id!, attachment.fileName)">
									<mat-icon class="file-item-icon document-icon" svgIcon="table_document"></mat-icon>
									<span class="elink-item-text file-name-text">{{ attachment.fileName }}</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>